<!-- Toggle Email History View Dialog -->
<ui-dialog
    [open]="isToggleEmailHistoryDialogOpen"
    [header]="
        canShowApplicantIndividualMessages ? 'applicant-tracker.hideEmailHistory' : 'applicant-tracker.showEmailHistory'
    "
    (closing)="closeEmailHistoryDialog()"
    #addColumnModal
>
    <p>{{ toggleEmailHistoryViewText() | translate }}</p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="closeEmailHistoryDialog()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="primary" (click)="closeEmailHistoryDialog(); toggleEmailHistory()">{{
            'yes' | translate
        }}</ui-button>
    </ui-dialog-footer>
</ui-dialog>

<div class="profile-layout reverse">
    <div class="profile-layout-content">
        <ui-card [withSpacing]="false">
            <div class="padding-x-3 padding-top-3">
                <mat-checkbox
                    *ngIf="hasRecruiterAccess"
                    class="hide-email-button padding-top-1"
                    [ngModel]="applicant.showMessages"
                    (click)="showEmailHistoryDialog($event)"
                >
                    <span> {{ 'applicant-tracker.visibleToHiringTeam' | translate }} </span>
                </mat-checkbox>

                <app-segment-header class="email-history-header" title="applicant-tracker.emailHistory">
                </app-segment-header>
                <span
                    *ngIf="hasRecruiterAccess || canShowApplicantIndividualMessages"
                    class="visible-to-hiring-team-text"
                >
                    {{
                        (canShowApplicantIndividualMessages
                            ? 'applicant-tracker.thisApplicantsEmailsAreVisibleToAdminsAndHiringTeam'
                            : 'applicant-tracker.thisApplicantsEmailsAreVisibleToAdminsOnly'
                        ) | translate
                    }}</span
                >
                <div
                    *ngIf="!hasRecruiterAccess && !canShowApplicantIndividualMessages"
                    class="invisible-to-hiring-team padding-bottom-6"
                >
                    <img style="max-width: 200px" src="/assets/illustrations/empty-box.png" />
                    <div>{{ 'applicant-tracker.anAdminHasHiddenThisApplicantsEmailHistory' | translate }}</div>
                </div>
            </div>
            <app-table
                class="table"
                *ngIf="canShowApplicantIndividualMessages || hasRecruiterAccess"
                [table]="emailHistoryTable"
                [useStickyHeader]="false"
                [showSearch]="false"
                [showOffset]="false"
                [showActionsPadding]="false"
                [embedded]="true"
                (rowClicked)="onApplicantIndividualMessageClicked($event)"
            >
                <app-empty-state
                    label="{{ 'applicant-tracker.thereIsNoEmailHistoryForThisCandidate' | translate }}"
                    src="/assets/illustrations/empty-inbox.png"
                >
                </app-empty-state>
            </app-table>
        </ui-card>
    </div>
    <div class="profile-layout-sidebar"><app-comments-mini></app-comments-mini></div>
</div>
